import { CookieKeys } from "../units/enums/CookieKeys"
import { setCookie } from "./cookies"

export function setJWTCookies(refreshToken: string, returnUrl: string, token: string) {
  setCookie(CookieKeys.AccessToken, token)
  setCookie(CookieKeys.RefreshToken, refreshToken)
  setCookie(CookieKeys.ReturnUrl, returnUrl)
}
